import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { Field, FieldArray } from "redux-form";
import FormNavigation from "../navigation.component";
import { Loader, FormField } from "pickups-ui-library";

import { formatPhone, phoneNormalize } from "utils/helpers";

import { FormGroup, Label, Button, Row, Col } from "reactstrap";
import { requiredValidate, emailValidate } from "../../helpers";

// Validation
const validate = (values) => {
  const errors = {};
  return errors;
};

const CreateUpdateDonor = (props) => {
  const {
    handleSubmit,
    onCancel,
    leadSourceOptions,
    pristine,
    submitting,
    error,
    handleSubmitAndShowCreateLocation,
    mapAddress,
    previousStep,
    phoneNumber,
  } = props;
  // const {leadSources, isFetching} = leadSourceOptions;

  return (
    <form onSubmit={handleSubmit}>
      <div className={"box p-4"}>
        <Field
          name="fname"
          type="text"
          component={FormField}
          label="First Name*"
          placeholder=""
          validate={[requiredValidate]}
        />
        <Field
          name="lname"
          type="text"
          component={FormField}
          label="Last Name*"
          placeholder=""
          validate={[requiredValidate]}
        />
        <Field
          name="email"
          type="text"
          component={FormField}
          label="Email*"
          placeholder=""
          validate={[requiredValidate, emailValidate]}
        />
        <Label>Phone Number*</Label>
        <div className={"form-control"}>{formatPhone(phoneNumber)}</div>

        {mapAddress ? (
          <FormGroup>
            <Label>Pickup Address</Label>
            <div
              style={{
                width: "100%",
                border: "1px solid #efefef",
                padding: "10px",
                color: "rgb(163, 163, 163)",
              }}
            >
              {mapAddress}
            </div>
          </FormGroup>
        ) : null}

        {error && <div className="error">{error}</div>}
      </div>
      <FormNavigation {...props} />
    </form>
  );
};

export default reduxForm({
  form: "CreateUpdateDonor",
  destroyOnUnmount: false,
  validate,
})(CreateUpdateDonor);
